import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setuserdata } from '../../features/auth'
import { useSnackbar } from 'notistack';
import axios from "axios";
import { Baseurl } from '../../constants/env';
import RemoveOrderModal from '../modals/RemoveOrderModal'
import { pdf } from '@react-pdf/renderer';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { StarIcon } from 'lucide-react';

const Userorder = () => {
  const { userdata, userid } = useSelector((state)=>state.auth);
   const [orderdata, setOrderata] = useState([]);
   const [change, setChange] = useState();
   const [reviewtab, setReviewTab] = useState(false);

   const [rating, setRating] = useState(0);
   const [orderid, setOrderId] = useState();
   const [reviews, setReviews] = useState({});
   const [reviewTexts, setReviewTexts] = useState({});
   const [reviewItem, setReviewitem] = useState([]);
   const [formStates, setFormStates] = useState({});

   const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: '#ffffff',
      padding: 30,
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    title: {
      fontSize: 24,
      textAlign: 'center',
      marginBottom: 20,
    },
    text: {
      fontSize: 12,
      marginBottom: 10,
    },
    arrayContainer: {
      marginLeft: 20,
      marginTop: 5,
      marginBottom: 10,
    },
    arrayItem: {
      fontSize: 12,
      marginBottom: 5,
    },
    objectProperty: {
      marginLeft: 10,
      fontSize: 11,
      color: '#444444',
    }
  });

  const handleStarClick = (index, productId, rating) => {
    setRating(rating)
    setReviews({
      ...reviews,
      [productId]: rating
    });
    setFormStates(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        rating: rating,
      },
    }));

  };

  const handleReviewTextChange = (productId, text) => {
    setReviewTexts({
      ...reviewTexts,
      [productId]: text
    });
  };

  const renderStarRating = (index,productId) => {
    const currentRating = reviews[productId];
    
    return (
      <div className="d-flex align-items-center">
    {[1, 2, 3, 4, 5].map((star) => (
  <i
    key={star}
    className={`bi bi-star-fill h-5 w-6 me-2 cursor-pointer ${
      star <= currentRating ? 'text-warning' : 'bi-star text-secondary' 
    }`}
    onClick={() => handleStarClick(index, productId, star)}
    style={{ fontSize: '1rem' }} 
  ></i>
))}
       
      </div>
    );
  };

  

  const renderValue = (value, level = 0) => {
    if (Array.isArray(value)) {
      return null; // Arrays are handled separately
    } else if (typeof value === 'object' && value !== null) {
      return `{Object}`;
    } else {
      return String(value);
    }
  };

  const fieldDisplayConfig = {
    // For 'projects' array, only show these fields
    projects: ['name', 'year'],
    // For 'team' array inside projects, only show these fields
    team: ['name'],
    // Add more array configurations as needed
  };

  // const shouldDisplayField = (arrayName, fieldName) => {
  //   if (!fieldDisplayConfig[arrayName]) {
  //     return true; // If no config for this array, show all fields
  //   }
  //   return fieldDisplayConfig[arrayName].includes(fieldName);
  // };

  const ArrayRenderer = ({ array, fieldName, level = 0, displayConfig }) => {
    return (
      <View style={styles.arrayContainer}>
        {array.map((item, index) => {
          if (typeof item === 'object' && item !== null) {
            return (
              <View key={`${fieldName}-${index}`}>
                <Text style={styles.arrayItem}>Item {index + 1}:</Text>
                {Object.entries(item).map(([key, value]) => {
                  // Check if this field should be displayed
                  if (!shouldDisplayField(fieldName, key, displayConfig)) {
                    return null;
                  }
                  
                  return (
                    <View key={`${fieldName}-${index}-${key}`} style={{ marginLeft: 15 }}>
                      {Array.isArray(value) ? (
                        <View>
                          <Text style={styles.objectProperty}>
                            {key}:
                          </Text>
                          <ArrayRenderer 
                            array={value} 
                            fieldName={key} 
                            level={level + 1} 
                            displayConfig={displayConfig}
                          />
                        </View>
                      ) : (
                        <Text style={styles.objectProperty}>
                          {key}: {renderValue(value, level + 1)}
                        </Text>
                      )}
                    </View>
                  );
                })}
              </View>
            );
          } else {
            return (
              <Text key={`${fieldName}-${index}`} style={styles.arrayItem}>
                Item {index + 1}: {String(item)}
              </Text>
            );
          }
        })}
      </View>
    );
  };
  
// PDF Document component
const MyDocument = ({ data, displayConfig }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.title}>Order Details</Text>
        {/* <Text style={styles.text}>This is a sample PDF generated with react-pdf.</Text> */}
        
        {/* Display the data passed to the document */}
        {data && Object.entries(data).map(([key, value]) => {
          // Skip fields that shouldn't be displayed at root level
          if (displayConfig.excludeRootFields && displayConfig.excludeRootFields.includes(key)) {
            return null;
          }
          
          return (
            <View key={key}>
              {Array.isArray(value) ? (
                <View>
                  <Text style={styles.text}>{key}:</Text>
                  <ArrayRenderer 
                    array={value} 
                    fieldName={key} 
                    displayConfig={displayConfig}
                  />
                </View>
              ) : (
                <Text style={styles.text}>
                  {key}: {renderValue(value)}
                </Text>
              )}
            </View>
          );
        })}
      </View>
    </Page>
  </Document>
);

const shouldDisplayField = (arrayName, fieldName, displayConfig) => {
  // If no display config is provided, show all fields
  if (!displayConfig || !displayConfig.arrayFields) {
    return true;
  }
  
  // If this array has specific field config
  if (displayConfig.arrayFields[arrayName]) {
    return displayConfig.arrayFields[arrayName].includes(fieldName);
  }
  
  // Default to show if no specific config
  return true;
};

  const generatePDF = async (sampleData) => {
    // Sample data - you can replace this with your actual data
    console.log(sampleData,'item');
    
    // const sampleData = {
    //   name: "John Doe",
    //   email: "john.doe@example.com",
    //   position: "Software Developer",
    //   description: "Experienced software developer with a focus on React applications"
    // };

    const displayConfig = {
      // Root fields to exclude completely
      excludeRootFields: ['userid','adminNotifications','userNotifications'],
      
      // For arrays, specify which fields to include for each array type
      arrayFields: {
        products: ['name', 'mrpprice', 'ourprice'],
        //team: ['name', 'role'],
        // For any array not listed here, all fields will be shown
      }
    };
  
    // Function to generate and download PDF
    
      // Create PDF document
      const blob = await pdf(<MyDocument data={sampleData} displayConfig={displayConfig} />).toBlob();
      
      // Create URL for the blob
      const url = URL.createObjectURL(blob);
      
      // Create temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Orderdeatils.pdf';
      
      // Simulate link click to download
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    

  }
      async function getorderdata() {
        await axios
          .get(`${Baseurl}/placeorder?id=${userid}`, { withCredentials: true })
          .then((resp) => {
            console.log(resp,'resporder');
            
            setOrderata(resp.data.productdata);
          })
          .catch((e) => {
            console.log(e.message)
          });
      }
const removeOrder = async (id) => {
}

 const removechange = (resp) => {
  setChange(resp)
 }

 const writeReview = (id,item) => {
setOrderId(id)
setReviewitem(item.products)
setReviewTab(!reviewtab)
 }

 const handleInputChange = (index, name, value) => {
  setFormStates(prevState => ({
    ...prevState,
    [index]: {
      ...prevState[index],
      [name]: value,
    },
  }));
};

const handleSubmitReview = async (index, itemId) => {
  if (!formStates[index]?.headline || !formStates[index]?.reviewText) {
    alert('enter required fields for review');
    return '';
  }
  
  let params = {
    productId: itemId,
     orderId:orderid,
     rating:rating,
    headline:formStates[index]?.headline,
    reviewText: formStates[index]?.reviewText
  }
  try{
    let result = await axios.post(`${Baseurl}/reviews?id=${userid}`,params)
    if(result){
      setChange(!change)
      alert('Product Reviewed')
      setReviewTab(!reviewtab)
    }
  }
  catch(e){
    alert(`${e.response.data.message}`)
    setChange(!change)
    setReviewTab(!reviewtab)
  }
};
       useEffect(() => {
        getorderdata()
      },[change])

   

  return (
    <div class="tab-pane fade show active" id="orders-tab">
    <div class="account-card">
      <h5>Orders</h5>
      <ul class="list-group">
      {orderdata?.map((item,index) => (
        <li class="list-group-item" key={index}>
          <strong>#{item?._id}</strong> - AED {item?.totalprice}
          {item?.products?.map((item,index) => (
            <span key={index}>
            <span> Product Names, {item?.name} </span>
            </span>
          ))}
          <span class="float-end text-success">{item?.OrderStatus ? item?.OrderStatus  :'Processing'}</span>
          <br /><small>Placed on {new Date(item?.createdAt)?.toLocaleString()}</small> |<small>
  {item?.orderDeliveryDate ? (
    <span>Delivered on {new Date(item?.orderDeliveryDate).toLocaleString()}</span>
  ) : (
    'Deliver Date Update Soon'
  )}
</small> | <small><a href='#'>Tracking link</a></small>
          <br/>
          <button class="btn btn-primary btn-sm btn-danger mb-0 me-2"  hidden={item?.status !== 'cancelled'} disabled={item?.status === 'cancelled'} onClick={() => removeOrder(item?._id)}>{ item?.status === 'cancelled' ? 'Order Canceled Amount Refunded within 7 Business Days' : 'Cancel Order'}</button>
          {item?.status === 'cancelled' || item?.OrderStatus === 'delivered' || item?.OrderStatus === 'Processing' ? <></> : <RemoveOrderModal id={item?._id} removechange={removechange} /> }
          {item?.OrderStatus === 'delivered'  ? <button disabled={new Date > new Date(new Date(item?.createdAt).getTime() + 3 * 24 * 60 * 60 * 1000) } class="btn btn-primary btn-sm btn-danger mb-0 me-2" onClick={() =>writeReview(item?._id,item)} >Write Review</button> : <></> }
          <button class="btn btn-secondary btn-sm  mb-0" onClick={() => generatePDF(item)}>Download Bill</button>
        </li>
      ))}

        {/* <li class="list-group-item">
          <strong>#12344</strong> - AED 150
          <span class="float-end text-warning">Processing</span>
          <br /><small>Placed on Jan 22</small>       
        </li> */}
      </ul>


{reviewtab ? <> <h5 className='mt-3'>Write a Review</h5>
<div>  
{reviewItem?.map((item, index) => (
        <div key={index} className='mt-3 mb-3'>
          <h6> {item?.name}</h6>
          <div className="ratings mb-2 mt-1"> {renderStarRating(index,item?._id)} </div>
          <div className="mb-2">
            <label className="form-label">Heading</label>
            <input
              type="text"
              name="headline"
              value={formStates[index]?.headline || ''}
              onChange={(e) => handleInputChange(index, 'headline', e.target.value)}
              className="form-control"
              placeholder="Title for your review"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Review</label>
            <textarea
              type="text"
              name="reviewText"
              rows={3}
              value={formStates[index]?.reviewText || ''}
              onChange={(e) => handleInputChange(index, 'reviewText', e.target.value)}
              className="form-control"
              placeholder="Describe your Experience"
            />
          </div>
          <button className="btn btn-danger btn-sm me-2" onClick={() => handleSubmitReview(index, item?._id)}>Save</button>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => setReviewTab(!reviewtab)}> Cancel</button>
        </div>
      ))}
           
      </div> </> : <></> }

      {/* <div className="pdf-generator">
      <h2>PDF Generator</h2>
      <button 
        onClick={generatePDF}
        style={{
          padding: '10px 15px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        Download as PDF
      </button>
    </div> */}

    </div>
  </div>
  )
}

export default Userorder
